<template>
<div>
    <!-- modal -->
    <b-modal id="titleFormModal" centered size="lg" no-close-on-backdrop ref="titleFormModal" :title=" $t('title.info')" :cancel-title=" $t('others.cancel_title')" :ok-title=" $t('others.ok_title')" cancel-variant="outline-secondary" @ok.prevent="addOrUpdate">
        <validation-observer ref="simpleRules">
            <b-row>
                <b-col class="col-12">
                    <b-form>
                        <label for="title-name-input">{{ $t('title.name') }}</label>
                        <b-form-group>
                            <validation-provider #default="{ errors }" :name=" $t('title.name')" rules="required">
                                <b-form-input id="title-name-input" v-model="titleName" size="sm" maxlength="50" :state="errors.length > 0 ? false:null" />
                                <small class="text-danger">{{ errors[0] }}</small>
                            </validation-provider>
                        </b-form-group>
                    </b-form>
                </b-col>
            </b-row>
            <b-row>
                <b-col class="col-12">
                    <b-form>
                        <label for="title-name-input">{{ $t('title.name_en') }}</label>
                        <b-form-group>
                            <validation-provider #default="{ errors }" :name=" $t('title.name_en')" rules="required">
                                <b-form-input id="title-name-en-input" v-model="titleNameEn" size="sm" maxlength="50" :state="errors.length > 0 ? false:null" />
                                <small class="text-danger">{{ errors[0] }}</small>
                            </validation-provider>
                        </b-form-group>
                    </b-form>
                </b-col>
            </b-row>
        </validation-observer>
    </b-modal>
</div>
</template>

<script>
export default {
    props: {
        getTitleList: {
            type: Function
        }
    },
    data() {
        return {
            id: 0,
            titleName: '',
            titleNameEn: ''
        }
    },
    methods: {
        showInfo(id) {
            this.$refs['titleFormModal'].show()
            this.id = id
            const data = {
                id: this.id
            }
            const controller = {
                name: 'Title'
            }
            const payload = {
                data: data,
                controller: controller
            }
            this.$store.dispatch('moduleAuth/getInfo', payload).then((response) => {
                if (response.data.resultStatus == true) {
                    this.titleName = response.data.title.name
                    this.titleNameEn = response.data.title.nameEn
                } else {
                    this.$bvModal.hide('titleFormModal')
                    this.$WarningAlert(response.data.resultMessage)
                }
            })
        },
        addOrUpdate() {
            const data = {
                id: this.id,
                name: this.titleName,
                nameEn: this.titleNameEn
            }
            const controller = {
                name: 'Title'
            }
            const payload = {
                data: data,
                controller: controller
            }
            this.$refs.simpleRules.validate().then(success => {
                if (success) {
                    this.$store.dispatch('moduleAuth/save', payload).then((response) => {
                        if (response.data.resultStatus == true) {
                            this.$bvModal.hide('titleFormModal')
                            this.getTitleList()
                            this.$SaveAlert()
                        } else {
                            this.$WarningAlert(response.data.resultMessage)
                        }
                    })
                }
            })
        },
    }
}
</script>

<style lang="scss">
[dir=ltr] .modal-header .close {
    margin: -0.4rem -0.4rem -0.8rem auto;
}

[dir] label {
    margin-bottom: 0.2857rem;
    font-weight: bold;
}

.modal .modal-content {
    overflow: visible;
    margin-bottom: auto;
}

[dir] .invalid-tooltip {
    padding: 0.4rem 0.775rem !important;
    margin-top: -1.5rem !important;
    background-color: #ea5455 !important;
    border-radius: 0.358rem !important;
    left: 20px !important
}
</style>
